import React from "react";

// Küçük, yerel hata sınırı: tek bir bozuk alt bileşen (örn. bir menü) tüm
// sayfayı beyaz ekrana düşürmesin. Hata konsola AYNEN yazılır (yutulmaz).
class InlineErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`SERTEX bileşen hatası (${this.props.name || "bilinmiyor"}):`, error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          data-testid={this.props.testId || "inline-error"}
          className="px-3 py-2 rounded border border-rose-400/40 bg-rose-500/10 text-rose-200 text-[11px] font-mono"
        >
          Bu bölüm açılamadı. Sayfayı yenileyin.
        </div>
      );
    }
    return this.props.children;
  }
}

export default InlineErrorBoundary;
